const id = {
  menuTelesales: "Telesales",
  queue: "Antrian",
  followUp: "Follow Up",
  contacted: "Dihubungi",
  menuTelesalesHistory: "Riwayat Telesales",
  menuTelesalesHistorySubTitle:
    "Kamu bisa melihat riwayat telepon yang sudah selesai",
  downloadTelesalesHistoryDialogTitle: "Download Riwayat Telesales",
  unknownUser: "Unknown user",
};

const en = {
  menuTelesales: "Telesales",
  queue: "Queue",
  followUp: "Follow Up",
  contacted: "Contacted",
  menuTelesalesHistory: "Telesales History",
  menuTelesalesHistorySubTitle: "You can see the resolved call history",
  downloadTelesalesHistoryDialogTitle: "Download Telesales History",
  unknownUser: "Unknown user",
};

export default { id, en };
